module.exports = __webpack_public_path__ + "img/f2.5fd929c3.png";